import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDigitalGiftCardinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinejoin: "round",
		strokeWidth: 2,
		stroke: "currentColor",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M18 7h5M5 11h30m1 42v4.26c0 2 0 2.74-2 2.74H7c-1.333-.371-2-1.038-2-2V6c0-1.443.643-2 2-2h27c1.357 0 2 .557 2 2v14",
			strokeLinecap: "square"
		}), /* @__PURE__ */ _jsxs("g", {
			transform: "translate(14 20)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					strokeLinecap: "square",
					width: 45,
					height: 33,
					rx: 4
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13 21l5.21-5M23 21l-5-5M18 9.787L9 7v10.5l9-2.5zm0 0L27 7v10.421L18 15z",
					strokeLinecap: "square"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M1.086 12H8.9M18 .868V33m9.79-21h16.5",
					strokeLinecap: "round"
				})
			]
		})]
	})
});
export default SvgDigitalGiftCardinline;
